import React, { useEffect, useState } from "react";
import LaddaButton from "../../../components/buttons/laddaButton";
import { icons } from "../../../constants";
import SimpleTable from "../../../components/tables/simpleTable";
import { Grid } from "@mui/material";
import RegistrationModal from "./registrationModal";
import {
  getCurrentMonth,
  getCurrentMonthYearWithDate,
  getMonthName
} from "../../../utils/dateUtils";
import {
  callApiAsync,
  getOpportunityAction
} from "../../../services/apiService";
import { opportunityState } from "../../../constants/selectData";
import { isRiskVersion } from "../../../utils/riskAndOportunityVersion";

const getStateName = (state) => {
  if (state == null || state === "") return "";
  const item = opportunityState.find((i) => i.value === parseInt(state, 10));
  return item ? item.name : "";
};

const getOpportunityLevelName = (level) => {
  const l = parseInt(level, 10);
  switch (l) {
    case 1: return "Bajo";
    case 2: return "Medio";
    case 3: return "Alto";
    case 4: return "Superior";
    default: return "";
  }
};

const TabRegistrationMonth = ({
  dataOpportunity,
  getOpportunityData,
  isEditionAvailable,
  updateRiskupdateDate
}) => {
  const [openRegistrationModal, setOpenRegistrationModal] = useState(false);
  const [isEditableModal, setIsEditableModal] = useState(false);
  const [monthSelected, setMonthSelected] = useState("");
  const [tableData, setTableData] = useState([]);
  const [registrationData, setRegistrationData] = useState([]);

  const useVersion2 = isRiskVersion(dataOpportunity?.year, dataOpportunity?.month) === 2;

  const columnsBase = [
    { field: "monthName", header: "Mes" },
    { field: "month", header: "", columnType: "hide" },
    { field: "id", header: "", columnType: "hide" },
    { field: "action", header: "Acción del Tratamiento" },
    { field: "evidence", header: "Evidencias", columnType: "url" },
    { field: "actions", header: "", columnType: "actionButtons" }
  ];

  const columnsV2 = [
    { field: "monthName", header: "Mes" },
    { field: "month", header: "", columnType: "hide" },
    { field: "id", header: "", columnType: "hide" },
    { field: "action", header: "Acción del Tratamiento" },
    { field: "state", header: "", columnType: "hide" },
    { field: "stateName", header: "Estado" },
    { field: "opportunity_level", header: "", columnType: "hide" },
    { field: "opportunityLevelName", header: "Nivel de Oportunidad", columnType: "pills" },
    { field: "evidence", header: "Evidencias", columnType: "url" },
    { field: "actions", header: "", columnType: "actionButtons" }
  ];

  const columns = useVersion2 ? columnsV2 : columnsBase;

  const handleCloseRegistrationModal = () => {
    setMonthSelected("");
    setRegistrationData([]);
    setIsEditableModal(false);
    setOpenRegistrationModal(false);
    getOpportunityEvidence();
  };

  const openModalRegistrationModal = () => {
    setOpenRegistrationModal(true);
  };

  useEffect(() => {
    getOpportunityEvidence();
  }, []);

  const getOpportunityEvidence = async () => {
    callApiAsync(
      () => getOpportunityAction(dataOpportunity.opportunityMonthId),
      (data) => {
        const updatedData = data.map((item) => ({
          ...item,
          monthName: getMonthName(item.month),
          stateName: getStateName(item.state),
          opportunityLevelName: getOpportunityLevelName(item.opportunity_level)
        }));
        setTableData(updatedData);
      }
    );
  };

  return (
    <div>
      <div className="j-end mr-10">
        {isEditionAvailable && (
          <LaddaButton
            variant="contained"
            onClick={() => {
              setIsEditableModal(true);
              openModalRegistrationModal();
            }}
          >
            <div className="IHContainer align-rigth">
              <img className="btn-icon mr-10" src={icons.plusIcon} alt="icon" />
              <p className="button_text">Agregar</p>
            </div>
          </LaddaButton>
        )}
      </div>

      <div className="simple-table-container">
        <SimpleTable
          text="Evaluar"
          tableStyle={{ minWidth: "100%" }}
          buttons={[
            {
              type: "iconSwitch",
              icon: icons.editBlue,
              icon2: icons.eye,
              onClick: (rowData) => {
                var isEditable =
                  isEditionAvailable &&
                  getCurrentMonthYearWithDate(rowData.creation_date);
                setRegistrationData(rowData);
                setIsEditableModal(isEditable);
                setMonthSelected(rowData.monthName);
                openModalRegistrationModal();
              }
            }
          ]}
          data={tableData}
          columns={columns}
        />
      </div>
      <RegistrationModal
        opportunityId={dataOpportunity.id}
        opportunityData={dataOpportunity}
        openRegistrationModal={openRegistrationModal}
        handleCloseRegistrationModal={handleCloseRegistrationModal}
        isEditableModal={isEditableModal}
        monthSelected={
          monthSelected == "" ? getMonthName(getCurrentMonth()) : monthSelected
        }
        registrationData={registrationData}
        updateRiskupdateDate={updateRiskupdateDate}
        getOpportunityData={getOpportunityData}
      />
    </div>
  );
};

export default TabRegistrationMonth;
